import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { Alignment, ConnectionQuality, Localizations } from "../../../Shared/sharedTypes";
import ObserverNotification from "../../../Shared/ObserverNotification";
import {
    FiberManualRecord,
    PauseCircleFilled as PauseIcon,
    Warning as WarningIcon
} from "@material-ui/icons";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { ApplicationData } from "../../types";
import { RecordingOption } from "../../../Shared/GeneratedTypes";
import { displayConnectionWarnings } from "../../../Shared/Redux/Actions/sharedActions";

const mapState = (
    {
        activeObservers,
        connectionQuality,
        localizations,
        order,
        recordingState
    }: ApplicationData) => (
    {
        activeObservers,
        connectionQuality,
        localizations,
        order,
        recordingState
    });

const mapDispatch = {
    displayConnectionWarnings
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {
    alignment: Alignment,
    menuShown: boolean;
    displayConnectionWarnings: (value: number, consecutiveDrops: number) => void;
    showRecordingAlert: () => void;
}

function HeaderIcons({
    activeObservers,
    alignment,
    connectionQuality,
    displayConnectionWarnings,
    showRecordingAlert,
    localizations,
    menuShown,
    order,
    recordingState
}: PropTypes) {

    function displayNetworkQualityNotification() {
        displayConnectionWarnings(connectionQuality?.value ?? 100,
            connectionQuality?.consecutiveDrops ?? 0);
    }

    const recordingTooltipText = recordingState
        ? (localizations.recordingOn ?? "Session is currently being recorded")
        : (localizations.recordingOff ?? "Session is currently not being recorded");

    const neverRecord = order.sessionRecorded === RecordingOption.Never;
    const currentlyRecording = !neverRecord && order.product.displayRecordingToMentee === true && recordingState;
    const recordingPaused = !neverRecord && order.product.displayRecordingToMentee === true && !recordingState;

    const iconClass = alignment === Alignment.Left ? "headerIcon-left"
        : alignment === Alignment.Right ? "headerIcon-right"
            : "";

    return (
        <Grid item xs={3} sm={3} className={ alignment === Alignment.Right ? "right" : ""}>
            {currentlyRecording && (
                <Tooltip title={recordingTooltipText} className={iconClass}>
                    <IconButton onClick={() => { showRecordingAlert() }}>
                        <FiberManualRecord color={"error"} stroke="white" />
                    </IconButton>
                </Tooltip>
            )}

            {recordingPaused && (
                <Tooltip title={recordingTooltipText} className={iconClass}>
                    <IconButton onClick={() => { showRecordingAlert() }}>
                        <PauseIcon stroke="white" />
                    </IconButton>
                </Tooltip>
            )}

            <ObserverNotification
                activeObservers={activeObservers}
                alignment={alignment}
            />

            {(connectionQuality?.consecutiveDrops ?? 0) > 1 && (
                <div className={iconClass}>
                    <Tooltip title={localizations.badNetworkQuality}>
                        <IconButton>
                            <div className="badNetworkConnectionIndicator" onClick={() => { displayNetworkQualityNotification() }}>
                                <WarningIcon color="error" />
                            </div>
                        </IconButton>
                    </Tooltip>
                </div>
            )}
        </Grid>
    );
}

export default connector(HeaderIcons);
